// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-list-group .v-list-item{padding:0}.router-link-active .v-list-group .v-list-group__header{background:#e0e0e2ce}", ""]);
// Exports
module.exports = exports;
